// src/pages/NewsAndEvents/ArticleHome.js
import React from 'react';
import { Box, Typography, Container, Link, Card, CardContent, CardMedia, useTheme } from '@mui/material';
import { motion } from 'framer-motion';
import cardData from './NewsAndEvents/data/articles';

const ArticleHome = () => {
  const theme = useTheme();

  const leftVariant = {
    hidden: { x: -100, opacity: 0 },
    visible: { x: 0, opacity: 1, transition: { duration: 0.6 } }
  };

  const rightVariant = {
    hidden: { x: 100, opacity: 0 },
    visible: { x: 0, opacity: 1, transition: { duration: 0.6 } }
  };

  const homeArticles = cardData.filter((a) => a.category === 'HomeArticles');
  const [mainArticle, ...sideArticles] = homeArticles;

  return (
    <Box sx={{ py: 8 }}>
      <Container>
        <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, gap: 4 }}>
          
          {/* Left Side - Main Article */}
          <motion.div
            variants={leftVariant}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: false, amount: 0.4 }}
            transition={{ duration: 0.6 }}
            style={{ flex: 1 }}
          >
            {mainArticle && (
              <Card sx={{ boxShadow: 3, borderRadius: 2, backgroundColor: theme.palette.background.paper }}>
                <CardMedia
                  component="img"
                  image={mainArticle.img}
                  alt={mainArticle.title}
                  sx={{ height: 300, my: 2, borderRadius: 2, objectFit: 'cover' }}
                />
                <CardContent>
                  <Link
                    href={`/article/${mainArticle.id}`}
                    underline="none"
                    sx={{ display: 'block', mb: 1 }}
                  >
                    <Typography variant="h5" fontWeight="bold">
                      {mainArticle.title}
                    </Typography>
                  </Link>
                  <Typography variant="body1" mt={1} sx={{  color: theme.palette.text.primary, }}>
                    {mainArticle.text}
                  </Typography>
                </CardContent>
              </Card>
            )}
          </motion.div>

          {/* Right Side - Smaller Articles */}
          <motion.div
            variants={rightVariant}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: false, amount: 0.4 }}
            transition={{ duration: 0.6 }}
            style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '32px' }}
          >
            {sideArticles.map((item) => (
              <Card key={item.id} sx={{ display: 'flex', boxShadow: 3, borderRadius: 2, py: 1 }}>
                {item.img && (
                  <CardMedia
                    component="img"
                    image={item.img}
                    alt={item.title}
                    sx={{ width: 100, height: 100, objectFit: 'cover', my: 1, mx: 1 }}
                  />
                )}
                <CardContent>
                  <Link
                    href={`/article/${item.id}`}
                    underline="hover"
                    variant="body1"
                    fontWeight="bold"
                    sx={{ display: 'block', mb: 0.5 }}
                  >
                    {item.title}
                  </Link>
                  <Typography variant="body2" sx={{  color: theme.palette.text.primary, }}>
                    {item.text}
                  </Typography>
                </CardContent>
              </Card>
            ))}
          </motion.div>

        </Box>
      </Container>
    </Box>
  );
};

export default ArticleHome;
